/** @jsx jsx */

import { Fragment as _, useState, useRef, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import lizard from 'assets/lizard.svg';

const loadAssets = {} as any;

const BootScreen = ({ theme }) => {
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [fontsLoaded, setFontsLoaded] = useState(false);
  const [minDisplayTime, setMinDisplayTime] = useState(false);
  const [boot, setBoot] = useState(false);

  const bootScreen = useRef<HTMLDivElement>(null);

  const backgroundColor = theme.headerBackgroundColor || '#fff'; // lPink;

  useEffect(() => {
    if (!imagesLoaded) {
      loadAssets.loadImages = () => {
        setImagesLoaded(true);
        delete loadAssets.loadImages;
      };
    }

    if (!fontsLoaded) {
      loadAssets.loadFonts = () => {
        setFontsLoaded(true);
        delete loadAssets.loadFonts;
      };
    }
  });

  useEffect(() => {
    setTimeout(() => {
      !minDisplayTime && setMinDisplayTime(true);
    }, 1000);
  }, []);

  useEffect(() => {
    if (!bootScreen.current) { return }

    const fader = () => {
      setBoot(true);
    };

    bootScreen.current.addEventListener('transitionend', fader);

    return () => {
      if (!bootScreen.current) { return }
      bootScreen.current.removeEventListener('transitionend', fader);
    }
  }, [bootScreen.current]);

  console.log({
    imagesLoaded,
    fontsLoaded,
    minDisplayTime,
  });

  return !boot ? (
    <div
      ref={bootScreen}
      css={css`
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background: ${backgroundColor};
        opacity: ${imagesLoaded && fontsLoaded && minDisplayTime ? 0 : 1};
        transition: opacity 0.35s;
        z-index: 2147483638;
      `}
    >
      <img
        src={lizard}
        css={css`
          width: 30vw;
        `}
      />
    </div>
  ) : null;
};

export default BootScreen;
export { loadAssets };
